exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content-destination {\n  font-size: 18px;\n  white-space: normal;\n  line-height: 2em;\n}\n", ""]);

// exports
